import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addMaterialRequest = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Material Request',
    body
  );
  return data;
});
export const submitMaterialRequest = catchAsync(async (type, name) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.submit_doc?type=${type}&name=${name}`
  );
  return data;
});
export const cancelMaterialRequest = catchAsync(async (type, name) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.cancel_record?document=${type}&record=${name}`
  );
  return data;
});
export const updateMaterialRequest = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Material Request/${id}`,
    body
  );
  return data;
});

export const getMaterialRequest = catchAsync(
  async ({ key = '', value = '' }) => {
    let baseUrl =
      '/api/resource/Material Request?fields=["owner","material_request_type","schedule_date","transaction_date","status","name","docstatus"]&limit_start=0&limit_page_length=0&order_by=name desc';
    if (value) {
      if (key === 'schedule_date') {
        baseUrl += `&filters=[["schedule_date","Between",["${value}","${value}"]]]`;
      } else {
        baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
      }
    }
    const { data } = await axiosInstance.get(baseUrl);
    return data;
  }
);
export const deleteMaterialRequest = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Material Request/${record}`
  );
  return data;
});
export const getMaterialRequestDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Material Request/${id}`
  );
  return data;
});
export const getStockItems = catchAsync(async (text) => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_items?filters={"is_stock_item":1}'
  );
  return data;
});
export const getItemDetails = catchAsync(async (type, itemName) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_item_details?type=${type}&item=${itemName}`
  );
  return data;
});
